// CarruselDestacados.jsx
import { Grid, Typography } from "@mui/material";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../../../firebase/firebase";
import { useResponsive } from "../../../../Modulo_Responsive/Hooks/useResponsive";

const CarruselDestacados = ({
                                coleccion,
                                coleccionTitulo,        // 👈 ej: "comidas-titulo-destacados"
                                titulo = "Destacados",  // fallback texto si no hay imagen
                                alturaMovil = 260,
                                alturaEscritorio = 230,
                                onCargado,
                            }) => {
    const { sCell } = useResponsive();
    const [imagenes, setImagenes] = useState([]);
    const [imagenTitulo, setImagenTitulo] = useState(null);

    useEffect(() => {
        if (!coleccionTitulo) return;
        const unsub = onSnapshot(collection(db, coleccionTitulo), (snap) => {
            const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            docs.sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));
            setImagenTitulo(docs[0]?.url || null);
        });
        return () => unsub();
    }, [coleccionTitulo]);

    useEffect(() => {
        const unsub = onSnapshot(collection(db, coleccion), (snap) => {
            const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            docs.sort((a, b) => {
                if (a.orden !== undefined && b.orden !== undefined) return a.orden - b.orden;
                if (a.numero !== undefined && b.numero !== undefined) return a.numero - b.numero;
                return 0;
            });
            setImagenes(docs);
            onCargado?.(docs.length > 0);
        });
        return () => unsub();
    }, [coleccion]);

    if (imagenes.length === 0) return null;

    return (
        <Grid container justifyContent="center" alignItems="center" size={{ xs: 12 }}
              sx={{ pt: sCell ? 9 : 12, pb: 2 }}>

            {/* Título — imagen o texto fallback */}
            <Grid container justifyContent="center" size={{ xs: 12 }} sx={{ pb: 2 }}>
                {imagenTitulo ? (
                    <img
                        src={imagenTitulo}
                        alt={titulo}
                        style={{ maxWidth: sCell ? '100%' : '100%', display: 'block' }}
                    />
                ) : (
                    <Typography component="h2" sx={{
                        fontFamily: 'Abril Fatface',
                        fontSize: sCell ? 28 : 40,
                        fontWeight: 600,
                        textAlign: "center",
                        color: "black",
                        pt:2
                    }}>
                        {titulo}
                    </Typography>
                )}
            </Grid>

            {/* Carrusel */}
            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                <Splide options={{
                    pagination: false, arrows: false, drag: true,
                    type: 'loop', perPage: 2, perMove: 1,
                    speed: 400, autoplay: true, interval: 4000,
                    gap: '10px', padding: { right: '60px' },
                    breakpoints: { 768: { perPage: 1, padding: { right: '60px' } } },
                }}>
                    {imagenes.map((img) => (
                        <SplideSlide key={img.id}>
                            <img src={img.url} alt={img.nombre || "Destacado"}
                                 style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 25 }}
                            />
                        </SplideSlide>
                    ))}
                </Splide>
            </Grid>
        </Grid>
    );
};

export default CarruselDestacados;